import styled from 'styled-components';

export const MapZone = styled.div`
  .map {
    background-size: 1.389% 2.083%;
    background-image:
      linear-gradient(to right, white 1px, transparent 1px),
      linear-gradient(to bottom, white 1px, transparent 1px);

    .rotate-90 {
      transform: rotate(90deg);
    }
  }

  &.list {
    padding-top: 3vh;
    padding-bottom: 3vh;
    max-height: 90vh;
    overflow-y: scroll;
  }

  .bg-light-gray {
    background-color: lightgray;
  }

  .text-black {
    color: black !important;
  }
`;
